package io.horion.auth.presentation.ui.pages.profile

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.auth.di.koinGet
import io.horion.auth.domain.models.AppLanguage
import io.horion.auth.domain.models.ProfileSection
import io.horion.auth.presentation.ui.components.layouts.PageLayoutData
import io.horion.auth.presentation.ui.components.profile.ProfileHeader
import io.horion.auth.presentation.ui.components.profile.ProfileHomeSection
import io.horion.auth.presentation.ui.components.profile.ProfilePersonalInfoSection
import io.horion.auth.presentation.ui.components.profile.ProfileSecuritySection
import io.horion.auth.presentation.ui.components.profile.ProfileSidebar
import io.horion.auth.presentation.ui.pages.navigation.Screen
import io.horion.auth.presentation.ui.styles.LoadingScreen
import io.horion.auth.presentation.ui.theme.AuthTheme
import io.horion.auth.presentation.ui.theme.AuthTypography
import io.horion.auth.presentation.viewmodel.AuthViewModel
import io.horion.auth.utils.UserEnvironmentHelper
import org.jetbrains.compose.web.css.*
import kotlin.coroutines.cancellation.CancellationException

@InitRoute
fun initProfilePage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(AppLanguage.strings.pageTitleProfile))
}

@OptIn(DelicateApi::class)
@Page("/profile")
@Layout("io.horion.auth.presentation.ui.components.layouts.PageLayout")
@Composable
fun ProfilePage() {
    val viewModel = koinGet<AuthViewModel>()
    val ctx = rememberPageContext()
    val colors = AuthTheme.colors(ColorMode.current)

    var isCheckingSession by remember { mutableStateOf(true) }

    // Synchronisation session + chargement profil
    LaunchedEffect(Unit) {
        try {
            // 1. ÉTAPE D'ABORD LOCAL : Charger tout de suite le profil du LocalStorage s'il existe
            val hasLocalProfile = viewModel.loadProfileFromLocalStorage()

            // 2. Vérifier la validité du token
            val isConnected = viewModel.checkSession()

            if (!isConnected) {
                //viewModel.logout()
                ctx.router.navigateTo(Screen.Login.route)
            } else {
                // Si on a un profil local, on peut masquer le loader tout de suite !
                if (hasLocalProfile) {
                    isCheckingSession = false
                }

                // 3. ÉTAPE RÉSEAU : Aller chercher la version fraîche du profil sur le serveur en tâche de fond
                viewModel.fetchAndSyncProfile()

                // Masquer le loader si ce n'était pas encore fait
                isCheckingSession = false
            }
        } catch (e: CancellationException) {
            throw e
        } catch (e: Exception) {
            isCheckingSession = false
            ctx.router.navigateTo(Screen.Login.route)
        }
    }

    LaunchedEffect(viewModel.uiState.logoutSucceed) {
        if (viewModel.uiState.logoutSucceed) {
            viewModel.resetLogoutState()
            ctx.router.navigateTo(Screen.Login.route)
        }
    }

//    LaunchedEffect(Unit) {
//        try {
//            val isAlreadyConnected = viewModel.checkSession()
//            if (!isAlreadyConnected) {
//                ctx.router.navigateTo(Screen.Login.route)
//            } else {
//                // Session OK -> On charge les données du profil depuis l'API/BDD
//                viewModel.getProfile()
//                isCheckingSession = false
//            }
//        } catch (e: CancellationException) {
//            throw e
//        } catch (e: Exception) {
//            isCheckingSession = false
//            ctx.router.navigateTo(Screen.Login.route)
//        }
//    }


    var currentSection by remember { mutableStateOf(ProfileSection.HOME) }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .minHeight(100.vh)
    ) {
        if (isCheckingSession) {
            // 1. TANT QUE LA VERIFICATION TOURNE : On affiche UNIQUEMENT un loader plein écran
            LoadingScreen(colors)
//            Box(
//                modifier = Modifier
//                    .fillMaxSize()
//                    .background(colors.background), // Aligne sur ton thème
//                contentAlignment = Alignment.Center
//            ) {
//                SpanText(
//                    "Chargement du profil...",
//                    modifier = Modifier.fontSize(AuthTypography.body).color(colors.mutedText)
//                )
//            }
        } else {

            ProfileSidebar(
                currentSection = currentSection,
                onSectionChange = { currentSection = it },
                onLogout = {
                    viewModel.logout()
                }
            )

            Column(
                modifier = Modifier
                    .weight(1)
                    .minHeight(100.vh)
                    .backgroundColor(colors.background)
            ) {
                ProfileHeader(
                    currentSection = currentSection,
                    viewModel = viewModel,
                )

                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1)
                        .padding(32.px)
                ) {
                    when (currentSection) {
                        ProfileSection.HOME ->
                            ProfileHomeSection(viewModel = viewModel)

                        ProfileSection.PERSONAL_INFO ->
                            ProfilePersonalInfoSection(viewModel = viewModel)

                        ProfileSection.SECURITY ->
                            ProfileSecuritySection(viewModel = viewModel)
                    }
                }
            }
        }
    }
}